import React from "react";
import cn from "classnames";
import ruSvg from "./flags/ru.svg";
import gbSvg from "./flags/gb.svg";
import styles from "./country-flag.module.scss";


interface ICountryFlagProps {
    className?: string;
    title?: string;
    countryCode: "ru" | "gb";
}

export const CountryFlag: React.FC<ICountryFlagProps> = ({
                                                             countryCode,
                                                             className,
                                                             title
                                                         }) => {
    const flagMap = {
        "ru": ruSvg,
        "gb": gbSvg
    }

    return <img
        className={cn(styles.countryImg, className)}
        title={title}
        src={flagMap[countryCode]}
    />
};

